import { Form, Input, Select } from "antd";
import { useState } from 'react'
import { useLocation } from "wouter";
import { useModal } from "../../../customHooks/useModal";
import FormBox from "../../Atoms/FormBox/FormBox";
import FormTitle from "../../Atoms/FormTitle/FormTitle";
import InputFormContainer from "../../Atoms/InputFormContainer/InputFormContainer";
import Modal from "../Modal/Modal";
import iconProfileCreate from '../../../assets/iconProfileCreate.svg'
import Button from "../../Atoms/Button/Button";
import './DataCompanyForm.scss'
const { Option } = Select;

const DataCompanyForm = () => {
  const [isOpenModal, openModal, closeModal] = useModal(false)
  const [form] = Form.useForm();
  const [, setLocation ] = useLocation();
  const [disabledInput, setDisabledInput] = useState(false)

  const sendForm = (e) => {
    console.log(e); // Aqui el objeto con los valores del formulario
    openModal(true) // Si se envia el formulario correctamente, se muestra el modal
  };

  const clearForm = () => {
    form.resetFields()
    closeModal()
  }

  const goToDashboard = () => {
    closeModal()
    setLocation('/dashboard')
  }

  return (
    <>
    <div className={`buttons-container mt-30`}>
      <button onClick={() => setDisabledInput(false)} disabled={!disabledInput} className="button s-large m-auto grayColor outline">Cancelar Edición</button>
      <button onClick={() => setDisabledInput(true)} disabled={disabledInput} className="button s-large m-auto grayColor">Editar información</button>
    </div>
    <Form onFinish={sendForm}  form={form} >
      <FormBox>
        <FormTitle text="Datos de empresa" />

        <InputFormContainer label="Razón social:" indentificador="razon_social">
          <Form.Item
            name="razon_social"
            rules={[
              {
                required: true,
                message: "Por favor ingresa tu razon social!",
              },
            ]}
          >
            <Input size="large" placeholder="Inversiones 123456" disabled={!disabledInput} />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer
          label="RIF / Identificación fiscal:"
          indentificador="rif"
        >
          <Form.Item
            name="rif"
            rules={[
              {
                required: true,
                message: "Por favor ingresa tu rif!",
              },
            ]}
          >
            <Input size="large" placeholder="J-29952124-8" disabled={!disabledInput} />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer
          label="País de operación:"
          indentificador="pais"
          errorMessage="Por favor ingresa tu pais de operacion!"
        >
          <Form.Item
            name="pais"
            rules={[
              {
                required: true,
                message: "Por favor ingresa tu pais de operacion!",
              },
            ]}
          >
            <Select size="large" placeholder="Venezuela" disabled={!disabledInput}>
              <Option value="venezuela">Venezuela</Option>
            </Select>
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Ciudad:" indentificador="ciudad">
          <Form.Item
            name="ciudad"
            rules={[
              {
                required: true,
                message: "Por favor ingresa tu ciudad!",
              },
            ]}
          >
            <Input size="large" placeholder="Indica tu ciudad" disabled={!disabledInput} />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer
          spanTwo
          label="Dirección:"
          indentificador="direccion"
        >
          <Form.Item
            name="direccion"
            rules={[
              {
                required: true,
                message: "Por favor ingresa tu direccion!",
              },
            ]}
          >
            <Input size="large" placeholder="Dirección exacta" disabled={!disabledInput} />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Tamaño de empresa:" indentificador="size_org">
          <Form.Item name="size_org"  rules={[{ required: true, message: "Por favor ingresa el tamaño de la empresa!",},]}>
            <Input size="large" placeholder="20 personas" disabled={!disabledInput} />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Página web (opcional):" indentificador="pagina_web">
          <Form.Item name="pagina_web" >
            <Input size="large" placeholder="www.negocio.com" disabled={!disabledInput} />
          </Form.Item>
        </InputFormContainer>
          
        <InputFormContainer label="Móvil de empresa:" indentificador="movil_empresa:">
          <Form.Item name="movil_empresa" rules={[{required: true, message: "Por favor ingresa tu movil de empresa!",},]}>
            <Input size="large" placeholder="04245374810" disabled={!disabledInput} />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Teléfono de empresa:" indentificador="phone_empresa:">
          <Form.Item name="phone_empresa" rules={[{required: true, message: "Por favor ingresa el teléfono de la empresa!",},]}>
            <Input size="large" placeholder="02125374810" disabled={!disabledInput} />
          </Form.Item>
        </InputFormContainer>
        
  
        <InputFormContainer label="Email de empresa" indentificador="email_empresa" >
          <Form.Item name="email_empresa" rules={[{required: true,message: "Por favor ingresa tu email de empresa!",}, ]}>
            <Input size="large" placeholder="correo@empresa.com" disabled={!disabledInput} />
          </Form.Item>
        </InputFormContainer>
  

        {/* Parte 2 */}
        <FormTitle text="Redes sociales" />
        
        <InputFormContainer label="Facebook" indentificador="facebook" >
          <Form.Item name="facebook" >
            <Input size="large" placeholder="www.facebook.com/user/" disabled={!disabledInput}/>
          </Form.Item>
        </InputFormContainer>
        <InputFormContainer label="Instagram" indentificador="instagram" >
          <Form.Item name="instagram" >
            <Input size="large" placeholder="www.instagram.com/user/" disabled={!disabledInput}/>
          </Form.Item>
        </InputFormContainer>
        <InputFormContainer label="Linkedin" indentificador="linkedin" >
          <Form.Item name="linkedin" >
            <Input size="large" placeholder="www.linkedin.com/user/" disabled={!disabledInput}/>
          </Form.Item>
        </InputFormContainer>
        <InputFormContainer label="Twitter" indentificador="twitter" >
          <Form.Item name="twitter" >
            <Input size="large" placeholder="www.twitter.com/user/" disabled={!disabledInput}/>
          </Form.Item>
        </InputFormContainer>


        <FormTitle text="Tipo de empresa" />

        <InputFormContainer label="Sector:" indentificador="sector">
          <Form.Item
            name="sector"
            rules={[
              {
                required: true,
                message: "Por favor ingresa tu sector!",
              },
            ]}
          >
            <Select size="large" placeholder="Industrial" disabled={!disabledInput}>
              <Option value="industrial">Industrial</Option>
            </Select>
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Tipo de servicio:" indentificador="servicio">
          <Form.Item name="servicio" rules={[{required: true,message: "Por favor ingresa tu tipo de servicio!",},]} >
            <Select size="large" placeholder="Telecomunicaciones" disabled={!disabledInput}>
              <Option value="telecomunicaciones">Telecomunicaciones</Option>
            </Select>
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer
          label="Tipo de productos:"
          indentificador="productos"
        >
          <Form.Item
            name="productos"
            rules={[
              {
                required: true,
                message: "Por favor ingresa tu tipo de productos!",
              },
            ]}
          >
            <Select size="large" placeholder="Servicios de internet" disabled={!disabledInput}>
              <Option value="servicio_de_internet">
                Servicios de internet
              </Option>
            </Select>
          </Form.Item>
        </InputFormContainer>

        {/* <FormButtons onlyOne customClass="m-cols-2" /> */}

        <div className={`buttons-container mt-30 m-cols-2`}>
          <button disabled={!disabledInput} className="button s-large m-auto primary">Actualizar información</button>
        </div>
      </FormBox>
    </Form>
    
    <Modal
      isOpenModal={isOpenModal} 
      iconModal={iconProfileCreate}
      titleModal="Genial" 
      closeModal={() => closeModal()}
      subTitleModal="Se ha actualizado / creado tu información personal correctamente. Un correo llegará a tu bandeja, debes confirmarlo para continuar el proceso.">    
       <div className="buttons-container center mt-20">
          <Button content="Ir al dashboard" type="primary" customClass="s-large m-auto" clickHandler={() => goToDashboard()}/>
          <Button content="Cerrar" type="primary outline" customClass="s-large m-auto" clickHandler={clearForm}  />
       </div>
    </Modal> 

    </>
  );
};

export default DataCompanyForm;
